import * as React from "react"

import { cn } from "@/lib/utils"
import { Loader2 } from "lucide-react"

function Input({ className, type, label, loading, ...props }: React.ComponentProps<"input"> & { label?: React.ReactNode, loading?: boolean }) {
  return (
    <div className="p-1 relative">
      {label ? <div className="text-sm font-medium ml-1 mb-1 text-gray-500 flex items-center gap-1">{label}</div> : null}
      <input
        type={type}
        data-slot="input"
        className={cn(
          "border-input file:text-foreground placeholder:text-muted-foreground selection:bg-primary",
          "selection:text-primary-foreground flex h-9 w-full min-w-0 rounded-md border bg-transparent",
          "px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex",
          "file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none",
          "disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          `${!props.readOnly ? 'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]' : 'text-gray-500'}`,
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          className
        )}
        {...props}
      />
      {loading ? <Loader2 className="absolute right-2 bottom-2.5 animate-spin" color="gray" /> : null}
    </div>
  )
}

export { Input }
